import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { FontSizes, MediaQueries, Colours } from '../../tokens';
import ClickableElement from './ClickableElement';
import ellipsisStyles from '../../atoms/styles/ellipsisStyles';
const DESKTOP_WIDTH_CLOSED = 40;
const getStyles = createUseStyles({
    root: {
        width: '4.4rem',
        [MediaQueries.medium]: {
            width: 'auto',
            marginTop: '2.4rem',
        },
    },
    first: {
        [MediaQueries.medium]: {
            marginTop: '9.2rem',
        },
    },
    clickableElement: {
        [MediaQueries.large]: {
            paddingLeft: DESKTOP_WIDTH_CLOSED,
        },
    },
    iconContainer: {
        [MediaQueries.medium]: {
            width: DESKTOP_WIDTH_CLOSED,
        },
        [MediaQueries.large]: {
            position: 'absolute',
            top: 0,
            left: 0,
            paddingTop: 8,
            textAlign: 'center',
        },
    },
    label: {
        fontSize: FontSizes.Small,
        color: Colours.sexternary,
        lineHeight: '14px',
        display: 'block',
        ...ellipsisStyles,
        [MediaQueries.medium]: {
            display: 'none',
        },
        [MediaQueries.large]: {
            display: 'block',
            width: 104,
            fontSize: FontSizes.Regular,
            lineHeight: '24px',
            paddingLeft: 8,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
    },
    labelSelected: {
        color: Colours.primary,
    },
});
const NavOption = (props) => {
    const { className, icon, children, selected = false, to, disabled = false, onClick, isFirst = false, isExpanded, } = props;
    const styles = getStyles();
    return (React.createElement("li", { className: classNames(className, styles.root, {
            [styles.first]: isFirst,
        }) },
        React.createElement(ClickableElement, { onClick: onClick, className: styles.clickableElement, to: to, disabled: disabled, selected: selected, isExpanded: isExpanded },
            React.createElement("span", { className: styles.iconContainer }, icon),
            React.createElement("span", { className: classNames(styles.label, {
                    [styles.labelSelected]: selected,
                }) }, children))));
};
export default NavOption;
//# sourceMappingURL=NavOption.js.map